import React from 'react';

// import { RoundedButton } from '@/components/shared/RoundedButton'; // Change Art — pending artSeed persistence on backend (CTO)
import { EditInput } from '@/components/shared/Inputs';
import { generateAlbumGradient } from '@/helpers/albumGradient';
import {
	SettingsList,
	SettingsListItems,
} from '@/components/shared/SettingCard';
import { TeamSong } from '@/graphql';
import { getAcronym } from '@/helpers/textTransform';
import {
	Formik,
	FormikErrors,
	FormikHandlers,
	FormikHelpers,
	FormikTouched,
	FormikValues,
	useFormik,
} from 'formik';
import * as Yup from 'yup';

import {
	AddCustomSongDisplayProps,
	EAddCustomSongDisplayState,
} from '../../AddCustomSong';
import styles from '../AddCustomSongRoot.module.scss';

export type FirstStepFormSchema = {
	name: string;
	artist: string;
	ccli?: number;
};

export const firstStepValidationSchema: Yup.SchemaOf<FirstStepFormSchema> =
	Yup.object().shape({
		name: Yup.string()
			.required('Name is required')
			.max(80, 'Max 80 characters'),
		artist: Yup.string()
			.required('Artist is required')
			.max(80, 'Max 80 characters'),
		ccli: Yup.number().optional(),
	});

type ExtendOnChangeFn = (
	e: React.ChangeEvent<any>,
	field: keyof FirstStepFormSchema,
) => void;

export const FirstStep: React.FC<{
	formik: FormikHandlers & {
		values: FormikValues;
		errors: FormikErrors<FirstStepFormSchema>;
	};
	setTeamSong?: (
		stateFunction: (state: Partial<TeamSong>) => Partial<TeamSong>,
	) => void;
	additionalItems: SettingsListItems;
	albumGradient?: ReturnType<typeof generateAlbumGradient>;
	onChangeArt?: () => void;
}> = ({ formik, setTeamSong, additionalItems, albumGradient, onChangeArt }) => {
	const extendOnChange: ExtendOnChangeFn = (e, field) => {
		formik.handleChange(e);
		if (setTeamSong) {
			setTeamSong((state) => ({
				...state,
				[field]: e.target.value,
			}));
		}
	};

	return (
		<form
			onSubmit={formik.handleSubmit}
			id="asaphSignIn"
			className={styles['song-modal-root']}
		>
			<div className={styles['centered-items']}>
				<div className={styles['cover-image']} style={albumGradient?.style}>
					<span style={albumGradient ? { color: albumGradient.textColor } : undefined}>{getAcronym(formik.values.name)}</span>
				</div>
				{/* Change Art — pending artSeed persistence on backend (CTO)
				{onChangeArt && (
					<RoundedButton
						size="md"
						color="default"
						onClick={onChangeArt}
					>
						Change Art
					</RoundedButton>
				)}
			*/}
				<EditInput
					className={styles['name']}
					placeholder="Enter song name"
					name="name"
					autoComplete="off"
					value={formik.values.name}
					onChange={(e) => extendOnChange(e, 'name')}
					error={!!formik.errors.name}
					// errorText={formik.errors.name}
					helperText="Song name*"
				/>
				<EditInput
					className={styles['artist']}
					placeholder="Enter artist name"
					name="artist"
					autoComplete="off"
					size="md"
					value={formik.values.artist}
					onChange={(e) => extendOnChange(e, 'artist')}
					error={!!formik.errors.artist}
					// errorText={formik.errors.artist}
					helperText="Artist*"
				/>
				<EditInput
					className={styles['ccli']}
					placeholder="Enter CCLI #"
					name="ccli"
					autoComplete="off"
					size="md"
					value={formik.values.ccli}
					onChange={(e) => {
						formik.handleChange(e);
						if (setTeamSong) {
							setTeamSong((state) => ({
								...state,
								ccli: parseInt(e.target.value),
							}));
						}
					}}
					error={!!formik.errors.ccli}
					helperText="CCLI #"
				/>
			</div>
			<SettingsList items={additionalItems} noChevron />
		</form>
	);
};
